module.exports = __webpack_public_path__ + "img/361.a3ec8aad.png";